/* Chummys footer — behaviours (sections/chummys-footer.liquid)
   1. The four link columns are <details open> in the markup; on phones they
      become accordions (closed until tapped) and reopen when the viewport grows.
   2. The wordmark rises into the bottom edge the first time the footer is seen.
   3. The postcard leans in when you focus the email field, and gets franked
      the moment you submit (the page then reloads in its "sent" state).
   4. "Open now" on the board is worked out from the hours the client types in
      (Mo-Sa 08:00-16:00 / Su closed), always in London time. */
(() => {
  const DAYS = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];

  const parseHours = spec => {
    const rules = {};
    spec.split(/\n+/).forEach(line => {
      const m = line.trim().match(/^([A-Za-z,\-]+)\s+(closed|(\d{1,2}:\d{2})-(\d{1,2}:\d{2}))/i);
      if (!m) return;
      const days = [];
      m[1].split(',').forEach(part => {
        const [a, b] = part.split('-');
        const ia = DAYS.indexOf(a.slice(0, 2)), ib = b ? DAYS.indexOf(b.slice(0, 2)) : ia;
        if (ia < 0 || ib < 0) return;
        let i = ia;
        for (let n = 0; n < 7; n++) { days.push(i); if (i === ib) break; i = (i + 1) % 7; }
      });
      days.forEach(d => { rules[d] = /closed/i.test(m[2]) ? null : [m[3], m[4]]; });
    });
    return rules;
  };
  const mins = t => { const [h, m] = t.split(':').map(Number); return h * 60 + m; };
  const pretty = t => { const [h, m] = t.split(':').map(Number); const s = h % 12 || 12; return m ? `${s}:${String(m).padStart(2, '0')}${h < 12 ? 'am' : 'pm'}` : `${s}${h < 12 ? 'am' : 'pm'}`; };

  class ChummysFooter extends HTMLElement {
    connectedCallback() {
      this.details = [...this.querySelectorAll('.chummys-footer__details')];
      this.mq = window.matchMedia('(max-width: 767px)');
      this.sync = () => this.details.forEach(d => { d.open = !this.mq.matches; });
      this.sync();
      this.mq.addEventListener('change', this.sync);

      const wrap = this.querySelector('.chummys-footer__mark-wrap');
      if (wrap && 'IntersectionObserver' in window) {
        const io = new IntersectionObserver(entries => {
          if (entries.some(e => e.isIntersecting)) { this.classList.add('is-in'); io.disconnect(); }
        }, { threshold: 0.15 });
        io.observe(wrap);
      } else {
        this.classList.add('is-in');
      }

      const input = this.querySelector('.chummys-footer__input');
      const form = this.querySelector('.chummys-footer__form');
      input?.addEventListener('focus', () => this.classList.add('is-focus'));
      input?.addEventListener('blur', () => this.classList.remove('is-focus'));
      form?.addEventListener('submit', () => this.classList.add('is-sending'));

      this.openToday();
    }

    openToday() {
      const cell = this.querySelector('[data-open-today]');
      const spec = (this.dataset.hours || '').trim();
      if (!cell || !spec) return;
      const rules = parseHours(spec);
      const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date());
      const get = t => parts.find(p => p.type === t)?.value || '';
      const day = DAYS.indexOf(get('weekday').slice(0, 2));
      const now = (Number(get('hour')) % 24) * 60 + Number(get('minute'));
      const rule = rules[day];
      const prefix = this.dataset.openPrefix || 'Coffee shop';
      let line, open = false;
      if (!rule) line = `${prefix} · closed today`;
      else if (now < mins(rule[0])) line = `${prefix} · opens ${pretty(rule[0])}`;
      else if (now < mins(rule[1])) { line = `${prefix} · open until ${pretty(rule[1])}`; open = true; }
      else line = `${prefix} · closed for today`;
      cell.querySelector('[data-open-line]').textContent = line;
      cell.classList.toggle('is-closed', !open);
      cell.hidden = false;
    }
  }
  if (!customElements.get('chummys-footer')) customElements.define('chummys-footer', ChummysFooter);
})();
